import { CustomEventNames } from 'state/mParticle';

// Refund Enums
export enum FormStatus {
  UNSENT = 'unsent',
  SUCCESSFUL_REFUND = 'successfulRefund',
  FAILED_REFUND = 'failedRefund',
}

export enum RefundReason {
  NEVER_ARRIVED = 'Order never arrived',
  MISSING_ITEMS = 'Missing items',
}

export enum CustomerInitiatedRefundEventName {
  FAILED_REFUND = CustomEventNames.FAILED_CUSTOMER_INITIATED_REFUND,
  SUCCESSFUL_REFUND = CustomEventNames.SUCCESSFUL_CUSTOMER_INITIATED_REFUND,
}
